export const TYPE_MESSAGE = {};
export const SOCKET_SEND_TYPE = (() => {
  return {
    SCREENSHOT_COMPUTER: "screenshot-computer",
    RESTART_COMPUTER: "restart-computer",
    SHUTDOWN_COMPUTER: "shutdown-computer",
    MESSAGE_TEXT: "message-text",
    ALL_APPLICATIONS_COMPUTER: "all-applications-computer",
    CLOSE_APPLICATION_COMPUTER: "close-application-computer",
    LOCK_COMPUTER: "lock-computer",
    UNLOCK_COMPUTER: "unlock-computer",
    START_COMPUTER: "start-computer",
    JOIN_COMPUTER_SESSION_MESSAGE: "join-computer-session-message",
    CALL_STAFF_ACK: "call-staff-ack",
  };
})();

export const SOCKET_LISTEN_TYPE = (() => {
  return {
    SCREENSHOT_COMPUTER_RECEIVED: "screenshot-computer-received",
    SHUTDOWN_COMPUTER_RECEIVED: "shutdown-computer-received",
    RESTART_COMPUTER_RECEIVED: "restart-computer-received",
    MESSAGE_TEXT_RECEIVED: "message-text-received",
    ALL_APPLICATIONS_COMPUTER_RECEIVED: "all-applications-computer-received",
    COMPUTER_STATUS_RECEIVED: "computer-status-received",
    CREATE_ORDER_RECEIVED: "create-order-received",
    CUSTOMER_CREATE_WALLET_TRANSACTION: "customer-create-wallet-transaction",
    UPDATE_ORDER_RECEIVED: "update-order-received",
    CONFIRM_ORDER_RECEIVED: "confirm-order-received",
    CANCEL_ORDER_RECEIVED: "cancel-order-received",
    CANCEL_ITEM_ORDER_RECEIVED: "cancel-item-order-received",
    COMPLETE_ORDER_RECEIVED: "complete-order-received",
    DONE_ORDER_RECEIVED: "done-order-received",
    CONFIRM_PAYMENT_ORDER_RECEIVED: "confirm-payment-order-received",
    WEBHOOK_PAYMENT_RECEIVED: "webhook-payment-received",
    CUSTOMER_CREATE_COMBO: "customer-create-combo",
    CUSTOMER_CREATE_RESERVATIONS: "customer-create-reservation",
    WEBHOOK_PAYMENT_SUCCESS: "webhook-payment-success",
    CALL_STAFF_RECEIVED: "call-staff-received",
    CALL_STAFF_CLOSED_RECEIVED: "call-staff-closed-received",
    OA_MESSAGE_RECEIVED: "oa-message-received",
  };
})();
